//require("./snippets/product-quick-view-modal");
require("./snippets/view-alternatives-modal");
require("./qf/global_listeners");
require("./qf/wishlistAsObject");
require("./qf/cart");
require("./qf/loadMore");
require("./qf/ModalController");

window.modalController = new ModalController()
window.wishlist = new WishlistObjectQf();
window.globalListeners = new GlobalListeners();
window.cart = new CartQf();